import { QueryClient, QueryCache } from '@tanstack/react-query';
import ServerErrorHandler from 'shared/feedback/ErrorHandler';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10000,
        retry: false,
      },
      mutations: {
        retry: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        const handler = query.meta?.errorHandler ?? ServerErrorHandler;
        handler(error);
      },
    }),
  });
}
